export default __webpack_public_path__ + "5cf3c9dca6184ec730ea0259ab4d58b3.jpg";